export default __webpack_public_path__ + "static/media/Group 3537.303bdfe0.jpg";